export const opinionIntentKey='wiki-chat-opinion-intent';
export const opinionIntentTTL=30*60*1000;

export function readOpinionIntent(storage){
 try{
  const value=JSON.parse(storage.getItem(opinionIntentKey));
  return value&&typeof value.termId==='string'&&Number.isFinite(value.createdAt)&&typeof value.anchor?.quote==='string'&&value.anchor.quote.length<=2000?value:null;
 }catch{return null;}
}

// Old or expired quotes remain readable, but never reuse stale source coordinates.
export function continueOpinion(intent,term,english,now=Date.now()){
 if(!intent||intent.termId!==term?.id)return null;
 const expired=now-intent.createdAt>=opinionIntentTTL||intent.createdAt>now;
 const changed=intent.anchor.field==='english'?intent.anchor.version!==english?.revision:intent.anchor.version!==term.version;
 if(expired||changed)return {type:'new',anchor:null,text:`「${intent.anchor.quote}」\n\n`,notice:expired?'選文已逾時，已保留引文；請重新反白定位，或提出條目意見。':'原文已有新版本，已保留引文；請重新反白定位，或提出條目意見。'};
 return {type:'new',anchor:intent.anchor};
}
